import React from 'react';
import OMSubmitButton from '../OMComponents/OMSubmitButton/OMSubmitButton';
import styles from './PaymentFailMessage.scss';

const PaymentFailMessage = (properties) => {
  const { translate, closeModal } = properties;
  return (
    <div className={styles.messageWrapper}>
      <div className={styles.title}>{translate('title')}</div>
      <div className={styles.text}>{translate('text')}</div>
      <OMSubmitButton
        title={translate('submit')}
        onClick={closeModal}
        disableSubmit
      />
    </div>
  );
};

export default PaymentFailMessage;
